import { SolitaireGame } from '../SolitaireGame';
import { MagicItem, MagicPlace } from './magicGroup';
import { getPlayablePyramidCards, canRemovePyramidCardPair, getNonPlayablePyramidCards } from '../utils/pyramid';

export class PyramidMagic {
    private game: SolitaireGame;

    constructor(game: SolitaireGame) {
        this.game = game;
    }

    findMagicMove(): MagicItem | null {
        console.log('[PYRAMID MAGIC] Looking for magic move');
        
        const firstPair = this.findFirstPair();
        if (firstPair) return firstPair;

        const wastePilePair = this.findWithWastePilePair();
        if (wastePilePair) return wastePilePair;

        const stockPilePair = this.findStockPilePair();
        if (stockPilePair) return stockPilePair;

        console.log('[PYRAMID MAGIC] No magic moves found');
        return null;
    }

    private findFirstPair(): MagicItem | null {
        const playableCards = getPlayablePyramidCards(this.game);
        const nonPlayableCards = getNonPlayablePyramidCards(this.game);

        for (let i = 0; i < playableCards.length; i++) {
            for (let j = 0; j < nonPlayableCards.length; j++) {
                const card1 = playableCards[i];
                const card2 = nonPlayableCards[j];

                if (canRemovePyramidCardPair(card1, card2)) {
                    const foundation = this.game.foundations[0];
                    return new MagicItem(card1, foundation, MagicPlace.AFTER, null, card2);
                }
            }
        }

        return null;
    }

    private findWithWastePilePair(): MagicItem | null {
        const lastCard = this.game.wastePile?.lastCard;

        if (lastCard) {
            const nonPlayableCards = getNonPlayablePyramidCards(this.game);

            for (let j = 0; j < nonPlayableCards.length; j++) {
                const card2 = nonPlayableCards[j];

                if (canRemovePyramidCardPair(lastCard, card2)) {
                    const foundation = this.game.foundations[0];
                    return new MagicItem(lastCard, foundation, MagicPlace.AFTER, null, card2);
                }
            }
        }

        return null;
    }

    private findStockPilePair(): MagicItem | null {
        const stockPile = this.game.stockPile;

        if (stockPile) {
            const nonPlayableCards = getNonPlayablePyramidCards(this.game);

            for (let i = 0; i < stockPile.cards.length; i++) {
                for (let j = 0; j < nonPlayableCards.length; j++) {
                    const card1 = stockPile.cards[i];
                    const card2 = nonPlayableCards[j];
    
                    if (canRemovePyramidCardPair(card1, card2)) {
                        const foundation = this.game.foundations[0];
                        return new MagicItem(card1, foundation, MagicPlace.AFTER, null, card2);
                    }
                }
            }
        }

        return null;
    }
} 